export const DEFAULT_STEP_1_FORM_NAME = 'FORGOT_EMAIL_STEP_1';
export const DEFAULT_STEP_2_FORM_NAME = 'FORGOT_EMAIL_STEP_2';
export const DYNAMIC_FORGOT_EMAIL = 'dynamic-forgot-email';
